export default{
  namespaced: true,
  state: () => ({
    step:1
  }),
  mutations: {
    setStep(state, step) { 
      state.step = step;
    }
  },
  actions: {
    SETSTEP({commit},step) {
      commit("setStep", step)
    }
  }
}